import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportingDataIcon = props => /*#__PURE__*/_jsx(SVGIconBase, Object.assign({
  "data-test-id": "vertical-nav-icon__reporting-data"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "m28,4v24h-3V4h3m-10.5,6.5v17.46h-3V10.5h3m-10.5,6.11v11.35h-3v-11.35h3M29.25,2h-5.5c-.41,0-.75.34-.75.75v27.25h7V2.75c0-.41-.34-.75-.75-.75h0Zm-10.5,6.5h-5.5c-.41,0-.75.33-.75.75v20.72h7V9.25c0-.41-.33-.75-.75-.75h0Zm-10.5,6.11H2.75c-.41,0-.75.33-.75.75v14.61h7v-14.61c0-.41-.33-.75-.75-.75h0Z"
  })
}));
export default ReportingDataIcon;